import React from 'react';
import { isMapShownAtom } from '../../jotai-store/isMapShow';
import { useAtom } from 'jotai';
const NoBoxesAndBagsWarningModal = ({ isOpen, open, onClose, handleUpdateBookingObject, handleSaveImagesToBackend }) => {
  const [isMapShown, setIsMapShown] = useAtom(isMapShownAtom);


  // Support both `isOpen` (component API) and `open` (existing usages).
  // If a parent passes `open={true}` (as in `VisionItemsScreen.jsx`),
  // this will make the modal visible.
  const visible = typeof isOpen === 'boolean' ? isOpen : !!open;
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#7876A1]/50 p-3] font-instrument">
      <div
        role="dialog"
        aria-modal="true"
        className="relative rounded-2xl shadow-2xl overflow-hidden font-instrument flex flex-col items-center text-center px-6"
        style={{ width: '328px', height: '337.84px', background: '#F6F6F6' }}
      >
        {/* Close button (top-left) - uses project's X icon */}
        <button
          onClick={onClose}
          aria-label="Close modal"
          className="absolute left-4 top-4 w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600"
        >
          <img src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="close" />
        </button>

        {/* Decorative red polygon placed top-left of modal (tweak position here if needed) */}
        <div style={{ top: '21px', right: '94px' }} className="absolute w-[48px] h-[48px] flex items-center justify-center z-50">

          <img
            src="/images/NewUiIcons/Polygon4.svg"
            alt="decorative polygon"



          />
          <img
            src="/images/NewUiIcons/AttentionIconlatest.svg"
            alt="info"
            className='absolute mt-1.5'
          />


        </div>

        {/* Centered box icon above the title. Change the image path if you'd like a different box icon. */}
        <div className="mt-8 relative">
          <img
            src="/images/NewUiIcons/ItemIcons2.svg"
            alt="box icon"
            className="object-contain"
            style={{ width: '103px', height: '103px' }}
          />
        </div>

        <h2 className="mt-3 text-[24px] font-semibold text-[#34318C]">Are you moving any
          boxes or bags?</h2>

        <p className="mt-2 text-[14px] text-[#34318C] font-normal leading-[18px] w-[226px] text-center">
          Most moves include a few, and they
          can affect timing.
        </p>

        <div className='flex justify-between items-center mt-[20px] w-full gap-x-2' >


          {/* Primary action button - keyboard focusable with aria-label. Calls onClose by default. */}
          <button
            onClick={async () => {
              onClose && onClose()
              const isSuccess = await handleSaveImagesToBackend();
              if (!isSuccess) {
                return;
              }
              setIsMapShown(true);
              handleUpdateBookingObject("tripStatus", "locations", "continue.without.boxes.and.bags")
            }}
            aria-label="Add boxes"
            className=" w-full bg-[#C8C6DF] text-[#34318C] h-[48px] rounded-[15px] font-semibold text-[14px] shadow-sm hover:bg-[#C8C6DF] focus:outline-none focus:ring-2 focus:ring-[#34318C]/30"
            style={{ maxWidth: '280px' }}
          >
            No, continue
          </button>
          {/* Primary action button - keyboard focusable with aria-label. Calls onClose by default. */}
          <button
            onClick={() => onClose && onClose()}
            aria-label="Add boxes"
            className=" bg-[#34318C] w-full text-white h-[48px] rounded-[15px] font-semibold text-[14px] shadow-sm hover:bg-[#2d2a6b] focus:outline-none focus:ring-2 focus:ring-[#34318C]/30"
            style={{ maxWidth: '280px' }}
          >
            Yes, add boxes
          </button>

        </div>

        {/* End of modal content. Tune spacing by adjusting mt- / px- values above. */}
      </div>
    </div>
  );
};

export default NoBoxesAndBagsWarningModal;
